import * as React from "react";
import * as styles from "./confirmation-modal.css";

const ConfirmationModal: React.FC<{
    isOpen: boolean;
    title: string;
    message: string;
    content: React.ReactNode;
}> = ({ isOpen, title, message, content }) => {
    return (
        <div className={`${styles.overlay} ${isOpen && styles.overlayActive}`}>
            <div className={styles.modal}>
                <div className={styles.modalTitle}>{title}</div>
                <div className={styles.modalMessage}>{message}</div>
                {content}
            </div>
        </div>
    );
};

export default ConfirmationModal;
